import "./Button.css";
import { Tooltip, tooltipClasses } from "@mui/material";
import { Fragment } from "react";
import { Link } from "react-router-dom";

export default function Button({
  id = "",
  icon = false,
  text,
  onClick,
  url = "",
  isExternalURL = false,
  className = "",
  component,
  variant,
  type = "",
  disabled,
  newTab = false,
  title = "",
  children,
  iconLeft = false,
  style,
}) {
  const slotProps = {
    popper: {
      sx: {
        [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
          {
            marginTop: "0.5rem",
          },
      },
    },
  };

  const classNames = [
    "Button",
    className,
    disabled && "disabled",
    variant && "ButtonBasic",
    variant, // available variants are in CSS under .Button.<variant>
  ]
    .filter(Boolean)
    .join(" ");

  const innerContent = children ? (
    children
  ) : (
    <ButtonContent
      component={component}
      text={text}
      icon={icon}
      iconLeft={iconLeft}
    />
  );

  const actionElement = url ? (
    <Link
      style={style}
      className={classNames}
      to={url}
      reloadDocument={isExternalURL}
      target={newTab ? "_blank" : ""}
      rel="noopener noreferrer"
      id={id}
    >
      {innerContent}
    </Link>
  ) : (
    <button
      style={style}
      className={classNames}
      type={type}
      onClick={type !== "submit" ? onClick : undefined}
      disabled={disabled}
      id={id}
    >
      {innerContent}
    </button>
  );

  if (!title) {
    return actionElement;
  }

  return (
    <Tooltip title={title} slotProps={slotProps}>
      {disabled ? (
        // wrapped in span to allow tooltips in case of disabled button
        <span style={{ display: "inline-block" }}>{actionElement}</span>
      ) : (
        actionElement
      )}
    </Tooltip>
  );
}

function ButtonContent({ component, text, icon, iconLeft }) {
  return component ? (
    <>{component}</>
  ) : (
    <div className="Button-container">
      {iconLeft ? (
        <Fragment>
          {icon && <ButtonIcon icon={icon} />}
          {text && <ButtonText text={text} />}
        </Fragment>
      ) : (
        <Fragment>
          {text && <ButtonText text={text} />}
          {icon && <ButtonIcon icon={icon} />}
        </Fragment>
      )}
    </div>
  );
}

function ButtonIcon({ icon }) {
  return <span className="Button-icon">{icon}</span>;
}

function ButtonText({ text }) {
  return <span className="Button-text">{text}</span>;
}
